// Custom React hooks
import { useAuth as useSupabaseAuth, useUserProfile } from './hooks/use-auth'

// Export Supabase auth hooks
export const useAuth = useSupabaseAuth
export const useUser = useUserProfile

// Re-export the permissions hook
export { usePermissions } from './hooks/use-permissions'
export { useOrganization } from './hooks/useOrganization'

// Re-export types for backwards compatibility
export type { AuthUser, AuthSession } from './hooks/use-auth'